import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";

// Styled Components
const VideoContainer = styled(Box)({
  position: "relative",
  width: "100%",
  height: "90vh",
  overflow: "hidden",
  backgroundColor: "#000", // Black background while video loads
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.85) 100%)",
    zIndex: 1,
    pointerEvents: "none",
  },
});

const StyledVideo = styled("video")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  filter: "brightness(0.65)",
  opacity: 0,
  transition: "opacity 0.5s ease-in-out",
  "&.loaded": {
    opacity: 1,
  },
});

const ContentOverlay = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2,
  padding: "0 24px",
});

const HomepageHeaderVideo = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoStarted, setVideoStarted] = useState(false);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    // Only show content after video is loaded and started playing
    if (videoLoaded && videoStarted) {
      setVideoReady(true);
    }
  }, [videoLoaded, videoStarted]);

  return (
    <VideoContainer>
      {/* Background Video */}
      <StyledVideo
        src="https://res.cloudinary.com/edajn7mf/video/upload/v1789857382/WhatsApp_Video_2026-09-20_at_4.05.49_AM.mp4"
        autoPlay
        muted
        loop
        playsInline
        className={videoReady ? "loaded" : ""}
        onLoadedData={() => setVideoLoaded(true)}
        onCanPlay={() => setVideoLoaded(true)}
        onPlay={() => setVideoStarted(true)}
        onPlaying={() => setVideoStarted(true)}
      />

      {/* Main Content */}
      <ContentOverlay>
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: "center",
              color: "white",
              opacity: videoReady ? 1 : 0,
              transition: "opacity 0.5s ease-in-out",
            }}
          >
            {/* Subtitle Badge */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={videoReady ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <Box
                sx={{
                  mb: 3,
                }}
              >
                <Typography
                  variant="overline"
                  sx={{
                    color: "#c1e328",
                    fontWeight: 600,
                    letterSpacing: 3,
                    fontSize: "0.75rem",
                  }}
                >
                  Next-Generation Robotics
                </Typography>
              </Box>
            </motion.div>

            {/* Main Heading */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={videoReady ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "1.50rem", sm: "2.5rem", md: "3.5rem", lg: "4rem" },
                  fontWeight: 700,
                  mb: 2.5,
                  letterSpacing: -1.5,
                  lineHeight: 1.15,
                  textShadow: "0 2px 30px rgba(0, 0, 0, 0.3)",
                }}
              >
                Building the Future of Physical AI
                <br />
                <Box
                  component="span"
                  sx={{
                    background: "linear-gradient(135deg, #c1e328 0%, #a0c020 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  for offroad robotic mobility 
                </Box>
              </Typography>
            </motion.div>

            {/* Description */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={videoReady ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 4,
                  color: "rgba(255, 255, 255, 0.85)",
                  maxWidth: 680,
                  mx: "auto",
                  lineHeight: 1.7,
                  fontSize: { xs: "0.875rem", md: "1rem" },
                  fontWeight: 400,
                }}
              >
                Robots that works on environments were most robots fail to operate
              </Typography>
            </motion.div>

          

            {/* CTA Buttons */}
            {/* <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent="center"
              sx={{
                animation: isVisible ? `${fadeInUp} 0.8s ease-out 1s both` : "none",
              }}
            >
              <PrimaryButton
                size="large"
                endIcon={<ArrowForward />}
                onClick={discoverBtnHandler}
              >
                Explore Solutions
              </PrimaryButton>
     
            </Stack> */}
          </Box>
        </Container>
      </ContentOverlay>
    </VideoContainer>
  );
};

export default HomepageHeaderVideo;
